// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: column;
}

.add-btn {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.add-btn button {
  height: 50px;
}

.list-container {
  height: 100%;
  overflow: auto;
}
.list-container table {
  width: 100%;
  border: 1px solid #e7e7e7;
}
.list-container table tr {
  height: 50px;
}
.list-container table .mat-header-row {
  background-color: #ffffff;
}
.list-container table .mat-row {
  border: 1px solid #e7e7e7;
}
.list-container table .mat-row:nth-child(odd) {
  background-color: #f6f6f6;
}
.list-container table .name,
.list-container table .desc {
  width: 250px;
}
.list-container table .edit {
  text-align: center;
  width: 50px;
  cursor: pointer;
}
.list-container table .mat-cell,
.list-container table .mat-header-cell {
  padding-left: 20px;
}
.list-container table .mat-cell:nth-child(1),
.list-container table .mat-header-cell:nth-child(1) {
  width: 50px;
}
.list-container table .letter {
  display: inline-block;
}
.list-container table .letter::before {
  content: " ";
}
.list-container table .letter::after {
  content: ",";
}
.list-container table .letter:last-child::after {
  content: "";
}

mat-form-field {
  width: 100%;
  padding: 0 20px;
}

.list-container-small {
  max-height: 300px;
  overflow: auto;
}
.list-container-small table {
  width: 100%;
  border: 1px solid #e7e7e7;
}
.list-container-small table tr {
  height: 50px;
}
.list-container-small table .mat-header-row {
  background-color: #ffffff;
}
.list-container-small table .mat-row {
  border: 1px solid #e7e7e7;
}
.list-container-small table .mat-row:nth-child(odd) {
  background-color: #f6f6f6;
}
.list-container-small table .name,
.list-container-small table .desc {
  width: 250px;
}
.list-container-small table .edit {
  text-align: center;
  width: 50px;
  cursor: pointer;
}
.list-container-small table .mat-cell,
.list-container-small table .mat-header-cell {
  padding-left: 20px;
}
.list-container-small table .mat-cell:nth-child(1),
.list-container-small table .mat-header-cell:nth-child(1) {
  width: 50px;
}
.list-container-small table .letter {
  display: inline-block;
}
.list-container-small table .letter::before {
  content: " ";
}
.list-container-small table .letter::after {
  content: ",";
}
.list-container-small table .letter:last-child::after {
  content: "";
}

.content {
  height: 100%;
}

.tab-content {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;
}
.tab-content__inner {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.tab-content table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #c5c5c5;
  overflow: hidden;
}
.tab-content table tr {
  border-bottom: 1px solid #c5c5c5;
}
.tab-content table td {
  padding: 10px;
  border-right: 1px solid #c5c5c5;
  text-align: center;
}
.tab-content table td:nth-child(1) {
  text-align: left;
}
.tab-content table td .example-margin {
  width: 100%;
  margin: 0 10px;
}

h3 {
  margin: 20px 0 0 20px;
}

.inherit {
  padding: 20px;
}

.save-btn {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-bottom: 1px solid #c5c5c5;
}

.btn {
  margin: 3px;
}

.delete {
  width: 5%;
}

.toolbar {
  background-color: #41444d;
  height: 55px;
  color: white;
  font-size: 25px;
  font-family: "Roboto", sans-serif;
}

.button-bar {
  background-color: white;
  height: 55px;
  font-size: 25px;
  font-weight: 100;
  border-bottom: 1px solid #e7e7e7;
  font-family: "Roboto", sans-serif;
}

.mat-active {
  background-color: #0078d7;
  font-family: "Rubik", sans-serif;
  text-transform: uppercase;
  color: white;
  font-size: 13px;
  font-weight: bold;
  width: 180px;
  margin-right: 10px;
}

.mat-stroke {
  background-color: white;
  border: 2px solid #0078d7;
  color: #0078d7;
  margin-right: 10px;
  font-weight: bold;
}

::ng-deep .mat-ink-bar {
  background-color: #01c4f5 !important;
}

::ng-deep .mat-checkbox-checked .mat-checkbox-background {
  background-color: #01c4f5 !important;
}

::ng-deep .mat-checkbox-indeterminate .mat-checkbox-background {
  background-color: #01c4f5 !important;
}

.list-container {
  height: auto;
  border: 1px solid #e7e7e7;
}
.list-container table {
  width: 100%;
}
.list-container table tr {
  height: 50px;
}
.list-container table .mat-header-row {
  background-color: #ffffff;
}
.list-container table .mat-header-cell {
  border-right: 1px solid #e7e7e7;
}
.list-container table .name,
.list-container table .desc {
  width: 250px;
}
.list-container table .mat-cell,
.list-container table .mat-header-cell {
  padding-left: 20px;
}
.list-container table .mat-cell:nth-child(1),
.list-container table .mat-header-cell:nth-child(1) {
  width: 50px;
}
.list-container table .delete {
  text-align: center;
  width: 6%;
  padding-left: 10px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/folders/folders.component.scss","webpack://./src/app/shared/list.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,aAAA;EACA,sBAAA;ADEF;;ACCA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;ADEF;ACAE;EACE,YAAA;ADEJ;;ACEA;EACE,YAAA;EACA,cAAA;ADCF;ACEE;EACE,WAAA;EACA,yBAAA;ADAJ;ACEI;EACE,YAAA;ADAN;ACGI;EACE,yBAAA;ADDN;ACII;EACE,yBAAA;ADFN;ACIM;EACE,yBAAA;ADFR;ACMI;;EAEE,YAAA;ADJN;ACOI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;ADLN;ACQI;;EAEE,kBAAA;ADNN;ACQM;;EACE,WAAA;ADLR;ACSI;EACE,qBAAA;ADPN;ACSM;EACE,YAAA;ADPR;ACUM;EACE,YAAA;ADRR;ACYQ;EACE,WAAA;ADVV;;ACiBA;EACE,WAAA;EACA,eAAA;ADdF;;ACiBA;EACE,iBAAA;EACA,cAAA;ADdF;ACiBE;EACE,WAAA;EACA,yBAAA;ADfJ;ACiBI;EACE,YAAA;ADfN;ACkBI;EACE,yBAAA;ADhBN;ACmBI;EACE,yBAAA;ADjBN;ACmBM;EACE,yBAAA;ADjBR;ACqBI;;EAEE,YAAA;ADnBN;ACsBI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;ADpBN;ACuBI;;EAEE,kBAAA;ADrBN;ACuBM;;EACE,WAAA;ADpBR;ACwBI;EACE,qBAAA;ADtBN;ACwBM;EACE,YAAA;ADtBR;ACyBM;EACE,YAAA;ADvBR;AC2BQ;EACE,WAAA;ADzBV;;AAtHA;EACE,YAAA;AAyHF;;AAtHA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAyHF;AAvHE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAyHJ;AAtHE;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;AAwHJ;AAtHI;EACE,gCAAA;AAwHN;AArHI;EACE,aAAA;EACA,+BAAA;EACA,kBAAA;AAuHN;AArHM;EACE,gBAAA;AAuHR;AApHM;EACE,WAAA;EACA,cAAA;AAsHR;;AAhHA;EACE,qBAAA;AAmHF;;AAhHA;EACE,aAAA;AAmHF;;AAhHA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,gCAAA;AAmHF;;AAhHA;EACE,WAAA;AAmHF;;AAhHA;EACE,SAAA;AAmHF;;AAhHA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAmHF;;AAhHA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,iCAAA;AAmHF;;AAhHA;EACE,yBAAA;EACA,gCAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAmHF;;AA/GA;EACI,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAkHJ;;AA/GA;EACE,oCAAA;AAkHF;;AA/GA;EACE,oCAAA;AAkHF;;AA/GA;EACE,oCAAA;AAkHF;;AA/GA;EACI,YAAA;EACA,yBAAA;AAkHJ;AA/GI;EACE,WAAA;AAiHN;AA/GM;EACE,YAAA;AAiHR;AA9GM;EACE,yBAAA;AAgHR;AA7GM;EACE,+BAAA;AA+GR;AA5GM;;EAEE,YAAA;AA8GR;AA3GM;;EAEE,kBAAA;AA6GR;AA3GQ;;EACE,WAAA;AA8GV;AA1GM;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA4GR","sourcesContent":["@import '../../shared/list';\r\n\r\n.content {\r\n  height: 100%;\r\n}\r\n\r\n.tab-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  overflow: auto;\r\n\r\n  &__inner {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n  }\r\n\r\n  table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    border: 1px solid #c5c5c5;\r\n    overflow: hidden;\r\n\r\n    tr {\r\n      border-bottom: 1px solid #c5c5c5;\r\n    }\r\n\r\n    td {\r\n      padding: 10px;\r\n      border-right: 1px solid #c5c5c5;\r\n      text-align: center;\r\n\r\n      &:nth-child(1) {\r\n        text-align: left;\r\n      }\r\n\r\n      .example-margin {\r\n        width: 100%;\r\n        margin: 0 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nh3 {\r\n  margin: 20px 0 0 20px;\r\n}\r\n\r\n.inherit {\r\n  padding: 20px;\r\n}\r\n\r\n.save-btn {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 20px;\r\n  border-bottom: 1px solid #c5c5c5;\r\n}\r\n\r\n.btn {\r\n  margin: 3px;\r\n}\r\n\r\n.delete {\r\n  width: 5%;\r\n}\r\n\r\n.toolbar {\r\n  background-color: #41444d;\r\n  height: 55px;\r\n  color: white;\r\n  font-size: 25px;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.button-bar {\r\n  background-color: white;\r\n  height: 55px;\r\n  font-size: 25px;\r\n  font-weight: 100;\r\n  border-bottom: 1px solid #e7e7e7;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.mat-active {\r\n  background-color: #0078d7;\r\n  font-family: 'Rubik', sans-serif;\r\n  text-transform: uppercase;\r\n  color: white;\r\n  font-size: 13px;\r\n  font-weight: bold;\r\n  width: 180px;\r\n  margin-right: 10px;\r\n}\r\n\r\n\r\n.mat-stroke{\r\n    background-color: white;\r\n    border: 2px solid #0078d7;\r\n    color:#0078d7;\r\n    margin-right: 10px;\r\n    font-weight:bold;\r\n  }\r\n\r\n::ng-deep .mat-ink-bar {\r\n  background-color: #01c4f5 !important;\r\n}\r\n\r\n::ng-deep .mat-checkbox-checked .mat-checkbox-background {\r\n  background-color: #01c4f5 !important;\r\n}\r\n\r\n::ng-deep .mat-checkbox-indeterminate .mat-checkbox-background {\r\n  background-color: #01c4f5 !important;\r\n}\r\n\r\n.list-container {\r\n    height:auto;\r\n    border: 1px solid #e7e7e7;\r\n\r\n  \r\n    table {\r\n      width: 100%;\r\n  \r\n      tr {\r\n        height: 50px;\r\n      }\r\n  \r\n      .mat-header-row {\r\n        background-color: #ffffff;\r\n      }\r\n\r\n      .mat-header-cell {\r\n        border-right: 1px solid #e7e7e7;\r\n      }\r\n\r\n      .name,\r\n      .desc {\r\n        width: 250px;\r\n      }\r\n  \r\n      .mat-cell,\r\n      .mat-header-cell {\r\n        padding-left: 20px;\r\n  \r\n        &:nth-child(1) {\r\n          width: 50px;\r\n        }\r\n      }\r\n\r\n      .delete {\r\n        text-align: center;\r\n        width: 6%;\r\n        padding-left: 10px;\r\n        cursor: pointer;\r\n      }\r\n\r\n    }\r\n  }\r\n\r\n  ",":host {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.add-btn {\r\n  height: 100px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 20px;\r\n\r\n  button {\r\n    height: 50px;\r\n  }\r\n}\r\n\r\n.list-container {\r\n  height: 100%;\r\n  overflow: auto;\r\n  // border: 1px solid #e7e7e7;\r\n\r\n  table {\r\n    width: 100%;\r\n    border: 1px solid #e7e7e7;\r\n\r\n    tr {\r\n      height: 50px;\r\n    }\r\n\r\n    .mat-header-row {\r\n      background-color: #ffffff;\r\n    }\r\n\r\n    .mat-row {\r\n      border: 1px solid #e7e7e7;\r\n\r\n      &:nth-child(odd) {\r\n        background-color: #f6f6f6;\r\n      }\r\n    }\r\n\r\n    .name,\r\n    .desc {\r\n      width: 250px;\r\n    }\r\n\r\n    .edit {\r\n      text-align: center;\r\n      width: 50px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .mat-cell,\r\n    .mat-header-cell {\r\n      padding-left: 20px;\r\n\r\n      &:nth-child(1) {\r\n        width: 50px;\r\n      }\r\n    }\r\n\r\n    .letter {\r\n      display: inline-block;\r\n\r\n      &::before {\r\n        content: '\\00a0'\r\n      }\r\n\r\n      &::after {\r\n        content: ','\r\n      }\r\n\r\n      &:last-child {\r\n        &::after {\r\n          content: ''\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\nmat-form-field {\r\n  width: 100%;\r\n  padding: 0 20px;\r\n}\r\n\r\n.list-container-small {\r\n  max-height: 300px;\r\n  overflow: auto;\r\n  // border: 1px solid #e7e7e7;\r\n\r\n  table {\r\n    width: 100%;\r\n    border: 1px solid #e7e7e7;\r\n\r\n    tr {\r\n      height: 50px;\r\n    }\r\n\r\n    .mat-header-row {\r\n      background-color: #ffffff;\r\n    }\r\n\r\n    .mat-row {\r\n      border: 1px solid #e7e7e7;\r\n\r\n      &:nth-child(odd) {\r\n        background-color: #f6f6f6;\r\n      }\r\n    }\r\n\r\n    .name,\r\n    .desc {\r\n      width: 250px;\r\n    }\r\n\r\n    .edit {\r\n      text-align: center;\r\n      width: 50px;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .mat-cell,\r\n    .mat-header-cell {\r\n      padding-left: 20px;\r\n\r\n      &:nth-child(1) {\r\n        width: 50px;\r\n      }\r\n    }\r\n\r\n    .letter {\r\n      display: inline-block;\r\n\r\n      &::before {\r\n        content: '\\00a0'\r\n      }\r\n\r\n      &::after {\r\n        content: ','\r\n      }\r\n\r\n      &:last-child {\r\n        &::after {\r\n          content: ''\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
